<template>
    <div id="tableContents">
      <tableContents></tableContents>
    </div>
</template>

<script>
    import tableContents from "@/common/reportMenu.vue";
    export default {
      components: {
        tableContents
      },
      mounted(){
          document.body.classList.add("no-scroll");
      }
    }
</script>
<style lang="scss" scoped>
#tableContents{
    /deep/ .tableContents{
        opacity: 1;
        position: static;
    }
}
</style>